import AzLabel from '@features/AzLabel/ui/AzLabel';

export default function AzLabelPage() {
  return <AzLabel />;
}
